import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'skye-app';

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry
      .addSvgIcon(
        'angular',
        sanitizer.bypassSecurityTrustResourceUrl('https://0t2.github.io/angular-material-notes/svg/angular.svg')
      )
      .addSvgIconInNamespace(
        'custom-svg',
        'angular',
        sanitizer.bypassSecurityTrustResourceUrl(
          'https://0t2.github.io/angular-material-notes/svg/angular_solidBlack.svg'
        )
      )
      .addSvgIconSetInNamespace(
        'core',
        sanitizer.bypassSecurityTrustResourceUrl('https://0t2.github.io/angular-material-notes/svg/core-icon-set.svg')
      )
      .addSvgIcon(`grocy`, sanitizer.bypassSecurityTrustResourceUrl(`assets/grocy/grocy.svg`))
      .registerFontClassAlias('fontawesome', 'fa');
  }
}
